/**
 * Configuration for app level constants
 */
const baseUrl = process.env.REACT_APP_API_URL

if (!baseUrl) {
  throw new Error("REACT_APP_API_URL is required")
}

export const BASE_URL = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`
